@if(maintenaceBanner()){
<div (click)="onClickMaintenance()"
  [class.cursor-pointer]="maintenaceBanner()?.redirectUrl"
  class="no-print flex items-center justify-center gap-2  lg:mx-w-fit lg:max-h-[90px] lg:h-[90px] h-[34px] px-4 bg-[#FFE18E]">
  <img [src]="maintenaceBanner()?.image" />
</div>
}
@else {
  @if(!isProUser() && !!promotionalBanner() && isBrowser()){
  <div [style.background-color]="promotionalBanner()?.backgroundColor"
    [class.banner-open]="showBanner() && bannerImageLoaded()"
    [class.banner-closed]="!showBanner() || !bannerImageLoaded()"
    class="no-print banner-collapse flex items-center justify-center gap-2 lg:mx-w-fit overflow-hidden px-4">
    <a [href]="promotionalBanner()?.redirectUrl" target="_blank" class="flex-1 flex justify-center">
      <img [src]="isMobileDevice() ? promotionalBanner()?.images?.mobile : promotionalBanner()?.images?.desktop"
        loading="lazy" [alt]="promotionalBanner()?.name" />
    </a>
    @if(isHomePage()){
    <span (click)="showBanner.set(false); $event.stopPropagation()"
      class="cursor-pointer icon-times-o inline-flex items-center justify-between text-[20px] lg:text-[28px] text-[#757575]"></span>
    }
  </div>
  }
}

@if(isHomePage()){
  @if(!isSupportingInfoLoading()){
  <div>
    <app-home-nav 
      [currentUrl]="currentUrl()" 
      [(showBanner)]="showBanner"
      [isEligibleForPersonalHiring]="isEligibleForPersonalHiring()" 
      [isAuthenticated]="isAuthenticated()"
      [isProUser]="isProUser()">
    </app-home-nav>
  </div>
  }
  @else {
    <div class="md:block hidden w-full bg-[#F9FAFB] h-[44px]">
      <div class="max-w-6xl mx-auto w-full flex items-center justify-between ">
        <div class="flex items-center gap-2 mt-3 pb-2">
          @for(item of iteration(); track $index){
          <ngx-skeleton-loader appearance="square"
            [theme]="{'background-color':'#E6E6E6', width: '80px', height: '8px', 'border-radius': '8px', margin: '0px'}" />
          }
        </div>
        <div class="mt-3">
          <ngx-skeleton-loader appearance="square"
            [theme]="{'background-color':'#F3F3F3', width: '120px', height: '18px', 'border-radius': '8px',margin:'0px'}" />
        </div>
      </div>
    </div>
  }
}
@if(isSupportingInfoLoading()){
  <div class="hidden max-w-6xl mx-auto w-full md:flex items-center justify-between py-2">
    <div>
      <ngx-skeleton-loader appearance="square"
        [theme]="{'background-color':'#EAEAEA', width: '110px', height: '40px', 'border-radius': '8px',margin:'0px'}" />
    </div>
    <div class="flex items-center gap-4">
      @for(item of iteration(); track $index){
      <ngx-skeleton-loader appearance="square"
        [theme]="{'background-color':'#EAEAEA', width: '115px', height: '12px', 'border-radius': '8px',}" />
      }
    </div>
    <div class="flex items-center gap-2">
      @for(item of iteration().slice(0,3); track $index){
      <ngx-skeleton-loader appearance="circle"
        [theme]="{'background-color':'#EEE', width: '40px', height: '40px','border':'#EAEAEA'}" />
      }
      <div>
        <ngx-skeleton-loader appearance="square"
          [theme]="{'background-color':'#EAEAEA', width: '120px', height: '18px', 'border-radius': '8px',margin:'0px'}" />
      </div>
    </div>

  </div>
  <div class="md:hidden block flex flex-col gap-4 p-3 bg-white">
    <div class="flex items-center justify-between">
      <div>
        <ngx-skeleton-loader appearance="square" [theme]="{
          'background-color': '#EEE',
          width: '88px',
          height: '32px',
          'border-radius': '4px',}"
          />
      </div>
      <div class="grid grid-cols-3 gap-1">
        @for(item of iteration().slice(0, 3); track $index){
          <ngx-skeleton-loader appearance="square" [theme]="{
            'background-color': '#EEE',
            width: '32px',
            height: '32px',
            'border': '1px solid #EAEAEA',
            'border-radius': '8px',}"
          />
        }
      </div>
    </div>
  </div>
}@else{
<header [class.hidden]="isCorporate()" class="no-print bg-white border border-[#E4E7EC] nav-shadow"
  *transloco="let t; currentLang as currentLang">


  <nav
    class="mx-4 md:mx-auto md:max-w-full  lg:max-w-6xl h-[60px] md:h-16 lg:h-[72px] flex items-center justify-between"
     [class]="isNotHomePage() ? 'max-width-nav' : ''" >
    <ul class="mb-0">
      <a [routerLink]="'/'" class="cursor-pointer">
        <img ngSrc='images/bdjobsLogo.webp' width="107" height="40" alt="bdjobs" class=" h-[40px]">
      </a>

    </ul>
    <ul class=" hidden md:flex md:flex-row md:items-center gap-4 justify-between h-[56px] md:h-16 lg:h-[72px]">
      <li class="relative flex items-center gap-1">
          <a #mybdjobsDropdown 
            [href]="`${dashBoardUrl}?lang=${currentLang}`"
            target="_blank"
            (mouseenter)="onMouseEnterMybdjobs()"
            (mouseleave)="onMouseLeaveMybdjobs()" class="relative inline-flex items-center cursor-pointer select-none">
            <img [src]=" environment.homeImageUrl + 'mybdjobs.svg'" alt="mybdjobs">
            <img [src]=" environment.homeImageUrl + 'icon-down.svg'" alt="arrow-down" [class.rotate-180]="isMybdjobsOpen()">
        </a>
        @if(isMybdjobsOpen()){
          <div 
            class="absolute bg-white !rounded-lg top-[47px] left-[6%] -translate-x-[4%] w-[696px] z-[9999] mt-[6px] shadow-[0_10px_25px_rgba(0,0,0,0.18),0_30px_90px_rgba(0,0,0,0.22)]
                        ring-1 ring-black/10"
            @dropdownAnimation
            (mouseenter)="onMouseEnterMybdjobs()"
            (mouseleave)="onMouseLeaveMybdjobs()">
            <img [src]=" environment.homeImageUrl + 'triangle.svg'" class="absolute -top-1.5 left-[10%] -translate-x-[22%] " />
            @for(section of mybdjobsItem; track $index){
            <div [ngClass]="$index === mybdjobsItem.length - 1 ? 'p-6':'pb-0 p-6'" class=" flex flex-col gap-4">
              <p class="text-[#475467] font-medium text-xs">{{activeLang() === 'en'? section.title.toUpperCase():
                section.bnTitle}}</p>
              <div class="flex flex-wrap gap-4 ">
                @for (item of section.item; track $index) {
                <a [href]="isAuthenticated() ? ( activeLang() ==='en' ? item.url : item.bnUrl) : `${signinUrl}?${item.params}&lang=${currentLang}`"
                  target="_blank" class="flex items-center gap-3 w-[200px] group">
                  <img [src]="item.imgName" class="bg-[#FCF3FA] rounded" />
                  <p class="text-[#344054] text-sm font-medium group-hover:text-[#B32D7D] ">{{ activeLang() === 'en'?
                    item.name: item.bnName }}</p>
                </a>
                }
              </div>
              @if ($index
              < mybdjobsItem.length - 1) { <hr class="mt-4 border-t border-[#EEEFF7]" />
              }
          
            </div>
            }
          </div>
        }
      </li>
      <div class="h-3 border-r-2 border-[#D0D5DD]  rounded "></div>
      <li class="relative flex items-center gap-1">
        <a #jobDropdown 
          [routerLink]="jobs_url" [queryParams]="{lang: currentLang}" 
          (mouseenter)="onMouseEnterJob()"
          (mouseleave)="onMouseLeaveJob()" 
          class="flex items-center gap-1 cursor-pointer relative h-[56px] md:h-16 lg:h-[72px]">
          <span class="text-[#344054] text-base font-medium">{{t('jobs')}}</span>
          <img [src]=" environment.homeImageUrl + 'icon-down.svg'" alt="arrow-down" [class.rotate-180]="isJobsOpen()">
        </a>
        @if(isJobsOpen()){
          <div class="absolute bg-white top-[72px] !rounded-lg -left-[22%] -translate-x-[22.5%] w-[696px] z-[9999] mt-[6px] shadow-[0_10px_25px_rgba(0,0,0,0.18),0_30px_90px_rgba(0,0,0,0.22)]
                  ring-1 ring-black/10"
            @dropdownAnimation 
            (mouseenter)="onMouseEnterJob()"
            (mouseleave)="onMouseLeaveJob()">
            <img [src]=" environment.homeImageUrl + 'triangle.svg'" class="absolute -top-1.5 left-[26%] -translate-x-[26%]" />
            <div class="bg-white p-6 rounded-lg flex flex-col gap-4">
              <p class="text-[#475467]  font-medium text-xs">{{t('JOBS')}}</p>
              <div class="flex flex-wrap gap-4">
                @for (item of jobsItem; track $index) {
                @if(isAuthenticated() || item.title !=='Early Access Jobs' ){
                <a (click)="onFilterUrlClick(item)" class="cursor-pointer flex items-center gap-3 w-[200px] group">
                  <img [src]="item.imageUrl" [ngClass]="$index < 2 ? 'p-2' : 'p-0'" class="bg-[#FCF3FA] rounded" />
                  <p class="text-[#344054] text-sm font-medium group-hover:text-[#B32D7D]">{{ activeLang() === 'en'?
                    item.title: item.bnTitle }}</p>
                </a>
                }
          
                }
          
              </div>
            </div>
          </div>
        }
      </li>

      <!-- @if(!hideCareerResource()){ -->
        <div class="h-3 border-r-2 border-[#D0D5DD] rounded"></div>
        <div #careerDropdown class="cursor-pointer relative flex items-center gap-1">
          <li 
            (click)="isCareerResourceShow.set(!isCareerResourceShow())" 
            (mouseenter)="onMouseEnterCareerResource()"
            (mouseleave)="onMouseLeaveCareerResource()" 
            class="cursor-pointer relative flex items-center gap-1">
            <span class="text-[#344054] text-base font-medium">{{t('CarResource')}}</span>
            <img [src]=" environment.homeImageUrl + 'icon-down.svg'" alt="arrow-down" [class.rotate-180]="isCareerResourceOpen()">
          </li>

          @if(isCareerResourceOpen()){
            <div 
              class="absolute top-[50px] left-[40%] -translate-x-[36%] z-[9999] max-w-[256px] mt-[6px] shadow-[0_10px_25px_rgba(0,0,0,0.18),0_30px_90px_rgba(0,0,0,0.22)]
              ring-1 ring-black/10 rounded-lg" 
              @dropdownAnimation
              (mouseenter)="onMouseEnterCareerResource()" 
              (mouseleave)="onMouseLeaveCareerResource()">
              <div class="absolute -top-2 left-[40%] w-0 h-0 border-l-[10px] border-r-[10px] border-b-[10px]
                          border-l-transparent border-r-transparent border-b-white ">
              </div>
              <div class="bg-white px-2 py-3.5 rounded-lg flex flex-col gap-4">
                <div class="flex flex-wrap gap-1">
                  @for (item of careerResourceItem; track $index) {
                  <a [routerLink]="activeLang() ==='en' ? item.url : item.bnUrl" 
                    class="flex items-center gap-2 w-[240px] hover:bg-gray-100 px-2 rounded-lg">
                    <p class="text-[#344054] text-sm font-medium py-2">
                      {{ activeLang() ==='en' ? item.title: item.bnTitle }}
                    </p>
                  </a>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      <!-- } -->

      <div class="h-3 border-r-2 border-[#D0D5DD]  rounded"></div>
      <li>
        <a href="https://mybdjobs.bdjobs.com/bdjobs-pro/bdjobs-pro-package-pricing" target="_blank"
          class="cursor-pointer">
          <img [src]=" environment.homeImageUrl + 'bdjobsPro.svg'" alt="bdjobsPro" class="">
        </a>
      </li>
    </ul>
    <ul class="flex items-center justify-end gap-0 md:gap-6">
      <li class="flex items-center gap-4">
        @if(isNotHomePage()){
        <div
          class="relative hidden md:inline-block w-[96px] shadow-sm rounded-full border border-gray-100 px-0.5 py-0.5">
          <input type="checkbox" id="changeLanguage" [checked]="activeLang() === 'bn'" (change)="toggleLang($event)"
            class="sr-only peer" />
          <label for="changeLanguage"
            class="toggle-label block h-7 cursor-pointer overflow-hidden rounded-full bg-white">
          </label>

          <div [class.left-0.5]="activeLang()==='en'" [class.left-0]="activeLang()==='bn'"
            class="toggle-button absolute top-[3px]  h-[27px] w-[46px] rounded-full  bg-[#c13e8a] transform transition-transform peer-checked:translate-x-full peer-checked:border-white">
          </div>

          <span
            class="pointer-events-none absolute left-3.5 top-[60%] -translate-y-1/2 h-[21px] transform text-[10px] font-semibold text-white peer-checked:text-[#757575]">
            ENG
          </span>
          <span
            class="pointer-events-none absolute right-3.5 top-[60%] -translate-y-1/2 h-[21px] transform text-[10px] font-semibold text-[#757575] peer-checked:text-white">
            বাংলা
          </span>
        </div>
        }

        @if(isAuthenticated() && !isMenuOpen()){
        <div class="flex items-center gap-x-5 relative">
          <div class="flex items-center gap-">
            <div class=" relative flex items-center gap-x-3 cursor-pointer" (click)="onClickMessage()">
              <div class="relative inline-flex p-2.5 h-[40px] hover:bg-[#FCF3FA] rounded-[50%]">
                <img [src]=" environment.homeImageUrl + 'mail.svg'" class="lg:h-5 lg:w-5 w-6 h-6 cursor-pointer" alt="">
              
                @if (messageList().length > 0) {
                <span class="absolute right-0 top-0 min-w-[18px] h-[18px] px-1
                           rounded-full bg-red-500 text-white text-[10px]
                           flex items-center justify-center leading-none">
                  @let messageCount = messageList().length > 9 ? '9+' : messageList().length;
                  {{ currentLang === 'en' ? messageCount : (messageCount | toBanglaNumber)}}
                </span>
                }
              </div>

              @if(isMessageOpen() && !isMobileDevice()){
              <div [class.top-[120px]]="isHomePage()" [class.top-[172px]]="showBanner() && !isProUser()"
                class="absolute bg-black/40 z-[9998] left-[10%] right-10" (click)="isMessageShow.set(false)">
              </div>
              <div @dropdownAnimation  #messagePanel (click)="$event.stopPropagation()" [class.top-[180px]]="showBanner() && !isProUser()"
                class="absolute top-full mt-[23px] w-[400px] z-[9999] max-w-[696px] max-h-[226px]  left-[-126px] ">
                <img [src]=" environment.homeImageUrl + 'triangle.svg'" class="absolute -top-1.5 left-[130px] " />


                <div class="bg-white rounded-lg flex flex-col shadow-[0_10px_25px_rgba(0,0,0,0.18),0_30px_90px_rgba(0,0,0,0.22)]
         ring-1 ring-black/10">
                  <div class="flex items-center justify-between px-6 py-4 ">
                    <div class="text-[20px] text-[#101828] font-semibold">{{t('message')}}</div>
                  </div>
                  <div class="border-b border-[#ddd] w-full"> </div>
                  <div >
                    <div
                      [class.max-h-[508px]]="messageList().length === 0" 
                      [class.overflow-y-auto]="messageList().length > 0"
                      class="max-h-[350px] overflow-hidden">
                      @for(message of messageList(); track $index ){

                      <a 
                        [href]="`${mybdjobsMsgUrl}?jobId=${message.jobId}`" target="_blank"
                        class="flex px-6 py-4 hover:bg-[#FCF3FA]" [ngClass]="message.isRead? 'bg-[#FCF3FA]': ''">
                        <div class="relative">
                          @if(message.companyLogo){
                            <img [src]="message.companyLogo" alt="" class="h-10 w-10 rounded-full">
                          }
                          @else {
                            <img [src]=" environment.homeImageUrl + 'avatar.svg'" alt="" class="h-8 w-8 rounded-full">
                          }
                        </div>
                        <div class="flex flex-col pl-4 ">
                          <div class="text-[14px] font-medium">{{message.companyName}}</div>
                          <div class="text-[14px]"> {{ 'sentInRole' | transloco: { jobTitle: message.jobTitle } }} </div>
                          <div class="flex gap-x-1 items-center mt-[6px]">
                            <div class=" ">
                              <img [src]=" environment.homeImageUrl + 'clock.svg'" alt="" class="h-3 w-3">
                            </div>
                            <div class="text-xs text-[#475467]">{{message.lastChattedOn | time: this.activeLang() }}</div>
                          </div>
                        </div>
                      </a>
                      
                      }
                      @empty {
                        <div class="flex flex-col items-center justify-center  overflow-hidden min-h-[308px]">
                          <img [src]=" environment.homeImageUrl + 'messages.svg'"
                            [class.-mt-24]="isProUser()"
                           class="-mt-12 block">
                          <div class="-mt-[136px] text-center gap-1">
                            <p class="text-center mb-1 mt-4 text-[#101828] text-xl font-semibold flex items-center justify-center">{{t('messages')}}
                            </p>
                            <p class=" max-w-[310px] mx-auto flex flex-col items-center justify-center gap-x-1 text-[#475467] text-sm text-center">
                              <span>{{t('messagesHint')}}</span>
                            
                              <span class=" block mx-auto text-center">
                                <span>{{t('feature')}}</span>
                              </span>
                            </p>
                            @if(!isProUser()){
                              <a [href]="pricingPageUrl" target="_blank"
                                class="mb-12 mt-4 mx-auto max-w-fit flex items-center justify-center text-center bg-[#0DB14B] hover:bg-[#008020] rounded-lg px-3.5 py-2.5 font-semibold text-sm text-white flex items-center gap-1.5">
                                <span>{{t('getBdjobsPro')}}</span>
                                <img [src]=" environment.homeImageUrl + 'arrow-right-white.svg'" />
                              </a>
                            }
                            
                          </div>
                        </div>
                        
                      }
                    </div>
                    @if(messageList().length > 0){
                      <div class="border-t border-[#E4E7EC]"></div>
                      <div class="flex justify-between items-center pb-4 px-6 pt-4 border-t border-[#E4E7EC] shadow-[0_-12px_14px_-4px_rgba(16,24,40,0.06),0_4px_10px_-2px_rgba(16,24,40,0.03)]">
                        <a href="https://mybdjobs.bdjobs.com/mybdjobs/employer-message.asp?p=m" target="_blank" class="ml-auto">
                          <div class="text-white bg-[#C63C92] rounded-lg px-3 py-2 text-[14px] font-semibold">{{t('viewAll')}}</div>
                        </a>
                      </div>
                  }
                  </div>
                </div>
              </div>
              }
            </div>

            <!-- notification -->
            <div class=" relative  flex items-center gap-x-3 cursor-pointer pr-2 sm:pr-0"
              (click)="onClickNotification()">
              <div class="relative inline-flex p-2.5 h-[40px] hover:bg-[#FCF3FA] rounded-[50%]">

              <img [src]=" environment.homeImageUrl + 'bell.svg'" class="lg:h-5 lg:w-5 w-6 h-6 cursor-pointer " alt="">
              @if (notifications().totalUnreadAlerts > 0) {
                <span class="absolute right-0 top-0 min-w-[18px] h-[18px] px-1
                                          rounded-full bg-red-500 text-white text-[10px]
                                          flex items-center justify-center leading-none">
                  @let notficationCount = notifications().totalUnreadAlerts > 9 ? '9+' : notifications().totalUnreadAlerts;
                  {{ currentLang ==='en' ? notficationCount : (notficationCount | toBanglaNumber) }}
                </span>
              }
              </div>

              <!-- isNotificationOpen() -->
              @if(isNotificationOpen() && !isMobileDevice()){
              <div [class.top-[120px]]="isHomePage()" [class.top-[172px]]="showBanner() && !isProUser()"
                class="absolute  bg-black/40 z-[9998] left-[10%] right-10 ">
              </div>
              <div @dropdownAnimation #notificationPanel (click)="$event.stopPropagation()"
                [class.top-[180px]]="showBanner() && !isProUser()"
                class="absolute top-full mt-[23px] w-[400px] z-[9999] max-w-[696px] max-h-[226px]  left-[-166px]">
                <img [src]=" environment.homeImageUrl + 'triangle.svg'" class="absolute -top-1.5 left-[170px] " />
                <div class="bg-white py-4 rounded-lg flex flex-col  shadow-[0_10px_25px_rgba(0,0,0,0.18),0_30px_90px_rgba(0,0,0,0.22)]
         ring-1 ring-black/10">
                  <div class="flex items-center justify-between px-6 mb-4">
                    <div class="text-[20px] font-semibold text-[#101828]">{{t('notifications')}}</div>
                    <!-- <div (click)="onCloseNotification()"><img src="images/x-close.svg" alt=""></div> -->
                  </div>
                  <div>
                    <!-- Tabs -->
                    <div class="flex gap-6 border-b border-[#E4E7EC] px-6">
                      <button class="pb-2 text-sm  cursor-pointer" [ngClass]="activeNotificationTab() === 'alerts'
                            ? 'text-[#C63C92] border-b-2 border-[#C63C92] font-semibold'
                            : 'text-[#667085] font-medium'" (click)="activeNotificationTab.set('alerts')">
                        {{t('alert')}}
                      </button>

                      <button class="pb-2 text-sm  cursor-pointer" [ngClass]="activeNotificationTab() === 'reminders'
                            ? 'text-[#C63C92] border-b-2 border-[#C63C92] font-semibold '
                            : 'text-[#667085] font-medium'" (click)="activeNotificationTab.set('reminders')">
                        {{t('rem')}}
                      </button>
                    </div>
                  </div>
                  <div class="">
                    @if(activeNotificationTab() === 'alerts'){
                    <div class="flex flex-col max-h-[350px] overflow-y-auto scrollbar-hide">
                      @for(alert of notifications().alerts; track $index){
                      <div class="flex items-start gap-2 px-6 py-3" [ngClass]="alert.timestamp === null ? 'bg-[#FCF3FA]' : ''" (click)="redirectNoti(alert, true)">
                      <div class="relative">
                          <img [src]="alert.icon" class="min-h-10 min-w-10 max-w-10 max-h-10 rounded-full" />
                          @if(alert.timestamp === null){
                          <img class="absolute  top-4 right-[46px]" [src]="environment.homeImageUrl + 'ellipse.svg'" alt="">
                          }
                      </div>

                        <div class="flex flex-col">
                          <div class="text-sm font-medium text-[#475467]">{{alert?.title}}</div>
                          @if(!isProUser() && (alert.notificationType === 4 || alert.notificationType === 6  || alert.notificationType === 13)){
                            <div class="text-sm text-[#344054] font-semibold ">{{t('anEmployer')}} {{ alert?.message | truncate : 90}}</div>
                          } @else if (alert.metadata && alert.metadata.name) {
                            <div class="text-sm text-[#344054] font-semibold ">{{ alert.metadata.name + ' ' + alert.message | truncate : 90}}</div>
                          } @else {
                            <div class="text-sm text-[#344054] font-semibold "> {{ alert.message | truncate : 90}} </div>
                          }

                          @if (alert.metadata) {
                            <div class="flex gap-x-1 items-center mt-[6px]">
                              <div class="">
                                <img [src]="environment.homeImageUrl + 'clock.svg'" alt="" class="h-3 w-3">
                              </div>
                              <div class="text-xs text-[#475467] text-[#475467]">{{alert.metadata.minutes | time: activeLang() }}</div>
                            </div>
                          }
                        </div>
                      </div>
                      <div class="border-b border-[#ddd] w-full "> </div>
                      }
                      @empty {
                      <div class="flex flex-col items-center justify-center pb-20 overflow-hidden min-h-fit">
                        <img [src]="environment.homeImageUrl + 'Alerts.svg'" class="-mt-12 block">
                        <div class="-mt-[136px] text-center gap-1">
                          <p class="text-center mb-1 mt-4 text-[#101828] text-xl font-semibold flex items-center justify-center">
                            {{t('alerts')}}
                          </p>
                        </div>
                      </div>
                      }
                    </div>
                    }
                    @if(activeNotificationTab() === 'reminders'){
                      <div class=" max-h-[350px] overflow-y-auto scrollbar-hide">
                        <div class="flex flex-col gap-4">
                          @for(reminder of notifications().reminders; track $index){
                          <div class="flex flex-col px-6" (click)="redirectNoti(reminder, false)">
                            <div class="text-sm text-[#344054] font-semibold pb-[6px]">
                              {{reminder.metadata.systemName}}
                            </div>
                            <div class="text-[#475467] text-[14px] font-semibold pb-[6px]">
                              {{reminder?.message}}
                            </div>
                            <div class="text-[#475467] text-[14px] font-medium pb-[6px]">
                              {{reminder?.metadata?.messageDetail}}
                            </div>
                            <div>
                              @if(reminder?.metadata?.imageUrl){
                                <img [src]="reminder.metadata.imageUrl" alt="" class="w-full h-[210px] rounded-lg">
                              }
            
                            </div>
                            <div class="flex gap-x-1 items-center mt-[6px]">
                              <div class="">
                                <img [src]="environment.homeImageUrl + 'clock.svg'" alt="" class="h-3 w-3">
                              </div>
                              <div class="text-xs text-[#475467] text-[#475467]">{{reminder.metadata.minutesAgo | time: activeLang() }}</div>
                            </div>
                          </div>
                          <div class="border-b border-[#ddd] w-full "> </div>
                          }
                          @empty {
                          <div class="flex flex-col items-center justify-center pb-20 overflow-hidden min-h-fit">
                            <img [src]="environment.homeImageUrl + 'Reminders.svg'" class="-mt-12 block">
                            <div class="-mt-[136px] text-center gap-1">
                              <p class="text-center mb-1 mt-4 text-[#101828] text-xl font-semibold flex items-center justify-center">
                                {{t('reminders')}}
                              </p>
                            </div>
                          </div>
                          }
                        </div>
                      </div>
            
                      }
                      <div class="bg-[#E4E7EC]"></div>
                      @if(
                      activeNotificationTab() === 'alerts'
                      ? (notifications().alerts.length) > 0
                      : (notifications().reminders.length) > 0
                      ) {
                      <div class="cursor-default flex justify-end items-center pt-4 px-6 border-t border-[#E4E7EC] shadow-[0_-12px_14px_-4px_rgba(16,24,40,0.06)]">
                        <button [disabled]="!notifications().totalUnreadAlerts" (click)="postMarkAllasReadNotification()" class="text-[#0E6596] text-[14px] flex items-center cursor-pointer disabled:cursor-not-allowed disabled:opacity-30">
                          <img [src]="environment.homeImageUrl + 'check.svg'" alt="" class="pr-[6px]">
                          <div>{{t('markAsRead')}}</div>
                        </button>
                        <a [href]="`${notificationUrl}?lang=${activeLang()}`" target="_blank"
                          class="ml-auto">
                          <div class="text-white bg-[#C63C92] rounded-lg px-3.5 py-2.5 text-[14px] font-semibold">
                            {{t('viewNotifications')}}
                          </div>
                        </a>
                      </div>
                      }
                    </div>
                  </div>
                </div>
                }
              </div>
            </div>

          <div class="hidden lg:flex relative  items-center gap-x-3 cursor-pointer " (click)="onClickProfile()">
            @if (supportingInfo() && supportingInfo().currentUser) {
            @let currentUser = supportingInfo().currentUser;
            <div class="relative">
              @if(currentUser?.photoUrl){
                <img [src]="currentUser?.photoUrl" class="h-10 w-10 rounded-full border border-[#D0D5DD]" alt="">
              }@else {
                @let name = currentUser.firstName+' '+ currentUser.lastName;
                <div
                  class="md:max-w-[40px] md:min-w-[40px] md:max-h-[40px] md:min-h-[40px] w-10 h-10 rounded-[50%] text-sm md:text-base
                                                                          flex items-center justify-center border-2 border-[#D0D5DD] text-[#667085] bg-[#F2F4F7]">
                  {{name | initials}}
                </div>
              }
              @if(isProUser()){
                <img [src]="environment.homeImageUrl + 'pro-badges.svg'" alt="" class="absolute bottom-0 -right-1 w-4.5 h-4.5">
              }
            </div>
            
            <div class="flex items-center">
              @let name = supportingInfo().currentUser.firstName+' '+ supportingInfo().currentUser.lastName;
              <div class="text-base font-medium text-[#101828]" [title]="name">{{name | truncate :14}} </div>
              <div class="">
                <img class="text-[#344054] w-4 h-4 ml-1" [src]="environment.homeImageUrl + 'icon-chevron-down.svg'" alt="" [class.rotate-180]="isProfileShow()">
              </div>
            </div>
            @if(isProfileOpen()){
            <div 
              
              [class.top-[120px]]="isHomePage()" [class.top-[172px]]="showBanner() && !isProUser()"
              class="absolute  bg-black/40 z-[9998] left-[10%] right-10 ">
            </div>
            <div @dropdownAnimation #profileDropdown (click)="$event.stopPropagation()" [class.top-[180px]]="showBanner() && !isProUser()"
              class="absolute top-full right-0 mt-6 w-[280px] z-[9999] max-w-[696px] max-h-[226px] ">
              <img [src]="environment.homeImageUrl + 'triangle.svg'" class="absolute -top-1.5 right-8 " />
              <div class="bg-white px-4 py-6 rounded-lg flex flex-col  gap-4 shadow-[0_10px_25px_rgba(0,0,0,0.18),0_30px_90px_rgba(0,0,0,0.22)]
         ring-1 ring-black/10 flex flex-col gap-3">
                <div class="flex  w-full relative items-center cursor-default">
                  <div class="relative">
                    @if(currentUser?.photoUrl){
                      <img [src]="currentUser?.photoUrl" alt="bdjobs profile picture" 
                        class="min-h-[54px] min-w-[54px] max-w-[54px] max-h-[54px] rounded-full border border-[#D0D5DD]">
                    }@else {
                    @let name = supportingInfo().currentUser.firstName+' '+ supportingInfo().currentUser.lastName;
                      <div
                        class="md:max-w-[54px] md:min-w-[54px] md:max-h-[54px] md:min-h-[54px] w-[54px] h-[54px] rounded-[50%] text-sm md:text-2xl
                                                          flex items-center justify-center border-2 border-[#D0D5DD] text-[#667085] bg-[#F2F4F7]">
                        {{name | initials}}
                      </div>
                    }
                    @if(isProUser()){
                      <img [src]="environment.homeImageUrl + 'pro-badges.svg'" alt="" class="absolute bottom-1 -right-1.5 w-4.5 h-4.5">
                    }
                  </div>
                  <div class="ml-3 flex flex-col justify-center h-full gap-0.5">
                    @let name = supportingInfo().currentUser.firstName+' '+ supportingInfo().currentUser.lastName;
                    <div class="text-lg text-title font-semibold" [title]="name">{{name | truncate : 14}}</div>
                    @if(!isProUser()){
                      <a href="https://mybdjobs.bdjobs.com/bdjobs-pro/bdjobs-pro-package-pricing"
                        class="bg-[#ECFDF3] text-[#067647] rounded-full text-[11px] font-medium w-fit px-2 py-0.5 border border-[#ABEFC6]">{{t('getBdjobsPro')}}
                        </a>
                    }
                    
                  </div>
                </div>
                <div class="border-b border-[#E4E7EC]"></div>
                <div class="flex flex-col">
                  @for (item of profileMenuItems; track $index) {
                    @if(isEligibleForPersonalHiring() || item.title !=='My Personal Hiring'){
                      <div class="flex items-center gap-2  ">
                        <a [href]="activeLang()==='en'? item.url: item.bnUrl" target="_blank"
                          class="flex-1 flex items-center gap-2 cursor-pointer text-[#344054] hover:text-[#182230] hover:bg-[#F9FAFB] py-3 px-4 rounded-md">
                          <img [src]="item.imageUrl" alt="" class="h-5 w-5" />
                          <div class=" text-sm font-medium">
                            {{ activeLang() ==='en' ? item.title: item.bnTitle }}
                          </div>
                          <!-- @if(item.isNew){
                          <span class="rounded-full bg-[#EEF4FF] px-2 py-0.5 text-xs font-medium text-[#175CD3] border border-[#B2DDFF]">
                            {{t('new')}}
                          </span>
                          } -->
                        </a>
                        
                      </div>
                    }
                  }
                
                <div class="mt-3" (click)="onClickSignout()">
                    <div class="flex items-center gap-3 hover:bg-[#FEF3F2]  px-2 text-[#F04438]  py-3 rounded-md">
                      <img [src]="environment.homeImageUrl + 'sign-out.svg'" alt="" class="h-5 w-5" />
                      <div class="text-sm font-medium">
                        {{t('signout')}}
                      </div>
                    </div>
                </div>
                </div>
              </div>
            </div>
            }
          }
          </div>
        </div>
        }
        @else{
        <div class="self-end flex items-center justify-end gap-4">
          <a [href]="`${signinUrl}?tp=signup`" target="_blank" role="button" class=" hidden border border-[#F0B1DE] hover:bg-[#FCF3FA] rounded-lg px-4 py-2.5 h-10 text-[#B32D7D] md:flex md:flex-row items-center justify-center
                   gap-2 font-semibold">
            {{t('createAccount')}}
          </a>
          <div (click)="onClickSignin()"  target="_blank" role="button" class=" hidden border border-[#F0B1DE] rounded-lg px-4 py-2.5 h-10 text-white bg-[#C63C92] hover:bg-[#B32D7D] md:flex md:flex-row items-center justify-center
                   gap-2 font-semibold cursor-pointer">
            {{t('signin')}}
          </div>

          <div class="relative hidden md:flex employer-dropdown">
            <button type="button" (click)="isEmployerMenuOpen.set(!isEmployerMenuOpen())"
              class="cursor-pointer rounded-lg text-[#475467] font-semibold text-sm flex flex-row items-center justify-center gap-1">
              {{ t('forEmployer') }}
              <img [src]="environment.homeImageUrl + 'icon-chevron-down.svg'" class="transition-transform" [class.rotate-180]="isEmployerMenuOpen()"
                alt="" />
            </button>
          
            <!-- Menu -->
            @if (isEmployerMenuOpen()) {
            <div 
            #employerDropdown
              class="absolute right-[-12%] top-[52px] mt-2 w-[268px] rounded-xl border border-gray-200 bg-white shadow-lg z-50">
              <!-- Arrow -->
              <div class="absolute -top-2 right-10 h-3.5 w-3.5 rotate-45 bg-white border-l border-t border-gray-200"></div>
            
              <div class="flex flex-col gap-1 py-1.5 px-2">
                <a 
                  href="https://recruiter.bdjobs.com/"
                  class="cursor-pointer w-full text-left px-2 py-2 text-sm text-secondary hover:bg-gray-50">
                  {{ t('signin') }}
                </a>
            
                <a 
                  href="https://recruiter.bdjobs.com/RecruiterAccount/register"
                  target="_blank"
                  class="cursor-pointer w-full text-left px-2 py-2 text-sm text-secondary hover:bg-gray-50">
                  {{ t('createAccount') }}
                </a>
              </div>
            </div>
            }

          </div>

        </div>
        }
      </li>
      @if(!isAuthenticated()){
      <div class="flex items-center gap-1.5">
        <a [href]="'https://mybdjobs.bdjobs.com/createaccount.asp'" target="_blank" role="button" class=" md:hidden flex items-center justify-center border border-[#F0B1DE] hover:bg-[#FCF3FA] rounded-lg px-2 py-1.5 h-10 text-[#B32D7D] text-xs md:hidden md:flex-row items-center justify-center
                gap-2 font-semibold">
          {{t('create')}}
        </a>

        <div (click)="onClickSignin()" target="_blank" role="button" class=" flex items-center justify-center  border border-[#F0B1DE] rounded-lg px-2 py-1.5 h-10 text-white bg-[#C63C92] text-xs hover:bg-[#B32D7D] md:hidden md:flex-row items-center justify-center
                gap-2 font-semibold cursor-pointer">
          {{t('signin')}}
        </div>
      </div>
      }
      @else{
      }
      <ul (click)="isMenuOpen.set(!isMenuOpen())" class=" block md:hidden pl-2.5">
        @if(isMenuOpen()){
        <img [src]="environment.homeImageUrl + 'cross.svg'" alt="menu" class="h-6 w-6">
        }@else {
        <img [src]="environment.homeImageUrl + 'menu.svg'" alt="menu" class="h-6 w-6">
        }
      </ul>
    </ul>
  </nav>

  <app-responsive-nav
    [(isMenuOpen)]="isMenuOpen"
    [messageList]="messageList()"
    [(isMessageRes)]="isMessageRes"
    [(isNotificationRes)]="isNotificationRes"
    [isAuthenticated]="isAuthenticated()"
    [isProUser]="isProUser()"
    [mybdjobsItemUrl]="mybdjobsItemUrl()"
    [activeLang]="activeLang()"
    [alerts]="isAuthenticated() ? notifications().alerts : []"
    [reminders]="isAuthenticated() ? notifications().reminders : []"
    [unreadNotification]="notifications().totalUnreadAlerts"
    [profileCompletionInfo]="profileCompletion()"
    [editProfilePercentage]="editProfilePercentage()"
    [videoCvPercentage]="videoCvPercentage()"
    [isEligibleForPersonalHiring]="isEligibleForPersonalHiring()"
    (filterUrlClick)="onFilterUrlClick($event)"
    (notificationClick)="redirectNoti($event.data, $event.isAlert)"
    (markAllAsReadClick)="postMarkAllasReadNotification()"
    (toggleButton)="toggleLang($event)">
  </app-responsive-nav>

  <div class="md:hidden block no-print" *transloco="let t; currentLang as currentLang">
    <nav
      class="fixed bottom-0 inset-x-0 z-[10] bg-white border-t border-gray-200 shadow-sm flex justify-around items-center h-14"
      style="will-change: transform;">
      <a [routerLink]="'/'" [class.text-[#B32D7D]]="currentUrl() === '/'"
        class="flex flex-col items-center text-xs text-[#98A2B3] font-medium">
        <img [src]="currentUrl() === '/' ? environment.homeImageUrl + 'home-selected.svg' : environment.homeImageUrl + 'home.svg'" alt="home">
        {{t('home')}}
      </a>
  
      <a [routerLink]="jobs_url" class="flex flex-col items-center text-xs">
        <img [src]="currentUrl() === jobs_url ? environment.homeImageUrl + 'jobs.svg' : environment.homeImageUrl + 'job-unselected.svg'" alt="jobs">
        <span [class.text-[#B32D7D]]="currentUrl() === jobs_url"
          class="text-[#98A2B3] font-medium text-xs">{{t('job')}}</span>
      </a>
  
      <a [href]="'https://mybdjobs.bdjobs.com/mybdjobs/welcome.asp'"
        class="flex flex-col items-center text-xs text-gray-600 hover:text-black">
        @let user = supportingInfo().currentUser;
        <div class="relative">
          @if(isBrowser() && user?.photoUrl){
            <img [src]="user?.photoUrl" class="h-6 w-6 rounded-full" alt="">
          }@else {
            <img [src]="environment.homeImageUrl + 'avatar2.svg'" class="h-6 w-6 rounded-full" alt="">
          }
          @if(isProUser()){
            <img [src]="environment.homeImageUrl + 'pro-badges.svg'" alt="" class="absolute -top-1.5 -right-2 w-4.5 h-4.5">
          }
        </div>
        
        <span class="text-xs text-[#98A2B3] font-medium">{{t('mybdjob')}}</span>
      </a>
    </nav>
  </div>
</header>
}